import $ from 'jquery'
import 'select2/dist/css/select2.css'
import 'select2'

// $('body').on('DOMNodeInserted', 'select', function () {
//     $(this).select2();
// });
$( document ).on('turbolinks:load', function() {
  var arr = {}
  $(document).on('select2:open', e => {
    const id = e.target.id;
    const target = document.querySelector(`[aria-controls=select2-${id}-results]`);
    target.focus();
  });
  $('.offline_company_search').select2({});
  $('.offline_user_search').select2({});
    // $("#stock_order_id").select2()

  function ts_select2_tickets(elem){
    elem.select2({
      ajax: {
        url: "/support/tickets/ticket_title_livesearch",
        method: "GET",
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            ticket_title: params.term,
            employee_eligibility: elem.attr("data-eligibility")
          };
        },

        processResults: function (data, params) {
          var previous = document.getElementsByClassName("ticket_title_search");
          res = data.data

          if (previous.length > 0) {
            for (let i = 0; i <= previous.length - 1; i++) {
              var res = res.filter(function (el){return (el.id).toString() != previous[i].value})
            }
          }
          return {
            results: res
          };
        },
        cache: true
      },

      placeholder: 'Select a ticket',
      minimumInputLength: 1,
      templateResult: formatRepo,
      templateSelection: formatRepoSelection
    });
  }


  $(document).on('click', '.add_fields', function(){
    console.log('add fields clicked')

    var elems = $(".ticket_title_search")

    elems.each(function(){
      if(!$(this).hasClass('select2-hidden-accessible')){
        ts_select2_tickets($(this));
      }
    })

  });


  ts_select2_tickets($('.ticket_title_search'));

  function formatRepo (repo) {
    if (repo.loading) {
      return repo.text;
    }

    var $container = $(
      "<div class='select2-ticket clearfix'>" +
        "<div class='select2-ticket_title'></div>" +
      "</div>"
    );

    $container.find(".select2-ticket_title").text(repo.ticket_title);
    arr[repo.id] = repo
    return $container;
  }

  function formatRepoSelection (repo) {
    console.log("repo", repo.id)
    if (arr[repo.id]) {
      // console.log("employee_salary", arr[repo.id]["employee_salary"])
      // localStorage.setItem("employee_salary", arr[repo.id]["employee_salary"])
    }
    return repo.text;
  }

});